import { localizer } from './../../../../i18n/localizer';

import { Component, Input, OnInit } from '@angular/core';

import {
  GetEnumValuesDto,
  GetOrganizationTransactionByIdDto,
} from 'src/app/core/api/models';
import { TranslationService } from 'src/app/i18n';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ListGroupItemModule } from 'src/app/shared/global/list-group-item/list-group-item.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';


@Component({
    selector: 'app-base-organization-transactions-detail',
    templateUrl: './base-organization-transactions-detail.component.html',
    styles: [
        `
      .log-text {
        height: 168px !important;
      }
    `,
    ],
    imports: [
        BaseIndexModule,
        ListGroupItemModule,
        MaterialModule,
    ]
})
export class BaseOrganizationTransactionsDetailComponent implements OnInit {
  //#region Properties

  @Input() model: GetOrganizationTransactionByIdDto;
  @Input() TypeCreditChangesEnumValues: GetEnumValuesDto[];
  @Input() TypeTransactionsEnumValues: GetEnumValuesDto[];

  localizer = localizer;
  fields = 'pages.organizationTransactions.form.fields.';

  //#endregion

  constructor(protected translationService: TranslationService) {}

  ngOnInit() {}
}
